import React from "react";
import { createRoot } from "react-dom/client";
import App, { type DmTarotConfig } from "./App";
import "./styles.css";

function normalizeConfig(raw: any): DmTarotConfig {
  return {
    theme: raw?.theme ?? "auto",
    newsletterTitle: raw?.newsletterTitle,
    newsletterSub: raw?.newsletterSub,
    newsletterEmbedHtml: raw?.newsletterEmbedHtml,
  };
}

function getConfig(rootEl: HTMLElement): DmTarotConfig {
  const rawAttr = rootEl.getAttribute("data-config");
  if (!rawAttr) return { theme: "auto" };

  try {
    const parsed = JSON.parse(rawAttr);
    return normalizeConfig(parsed);
  } catch {
    return { theme: "auto" };
  }
}

const rootEl = document.getElementById("dm-tarot-root");

if (rootEl) {
  const config = getConfig(rootEl);

  createRoot(rootEl).render(
    <React.StrictMode>
      <App config={config} />
    </React.StrictMode>
  );
}
